/**
 * Position
 */

export const TOP = 'top';
export const BOTTOM = 'bottom';
export const LEFT = 'left';
export const RIGHT = 'right';

/**
 * Alignment
 */

export const START = 'start';
export const END = 'end';
export const CENTER = 'center';

/**
 * Column
 */

export const MIN_COL_SPAN = 1;
export const MAX_COL_WIDTH = 100;
export const DEFAULT_BREAKPOINT = 'default';

/**
 * Sizes
 */
export const ATOM = 'atom';
export const BIT = 'bit';
export const BYTE = 'byte';
export const KILO = 'kilo';
export const MEGA = 'mega';
export const GIGA = 'giga';
export const TERA = 'tera';
export const PETA = 'peta';
export const EXA = 'exa';
export const ZETTA = 'zetta';

/**
 * Tooltip Types
 */

export const ALERT = 'alert';

/**
 * Shadows
 */

export const SINGLE = 'single';
export const DOUBLE = 'double';
export const TRIPLE = 'triple';

/**
 * Colors
 */

export const SUCCESS = 'success';
export const DANGER = 'danger';
export const WARNING = 'warning';
export const NEUTRAL = 'neutral';
export const PRIMARY = 'primary';

/**
 * Season Dates
 */
export const SEASON_END_DATE = '2025-04-16';
export const PLAYOFFS_START_DATE = '2026-04-18';

/**
 * Boom Season Codes
 */
export const SEASON_CODE = '2026-27 REG';
export const PLAYOFFS_CODE = '2026-27 PST';

/**
 * API
 */

export const INVALID_SET_ID = 'tim-hortons.6';
export const DUPLICATED_SET_ID = 'tim-hortons.7';
export const BAD_PLAYER_DATA = 'tim-hortons.8';

/**
 * Messaging
 */

export const CLOSE_WINDOW_MESSAGE_TYPE = 'CLOSE_WINDOW';
export const MPARTICLE_LOG_MESSAGE_TYPE = 'MPARTICLE_LOG';

/**
 * Analytics
 */

export const ANALYTICS_PREFIX = 'TNHC';
export const ANALYTICS_SUFFIX_STAGING = 'STAGING';
export const ANALYTICS_SUFFIX_PROD = 'PROD';

export const SKILL_TEST_OPEN = 'Skills Test Screen Displayed';
export const SKILL_TEST_OPTION_SELECTED = 'Skills Test Option Selected';
export const PLAY_NOW_CLICK = 'Play Now Screen Clicked';
export const GAME_INFO_CLICK = 'Game Info Screen Clicked';
export const HISTORY_CLICK = 'History Screen Clicked';
export const LEADERBOARD_CLICK = 'Leaderboard Screen Clicked';
export const PLAY_NOW_OPEN = 'Play Now Screen Displayed';
export const GAME_INFO_OPEN = 'Game Info Screen Displayed';
export const HISTORY_OPEN = 'History Screen Displayed';
export const LEADERBOARD_OPEN = 'Leaderboard Screen Displayed';
export const PICKS_SUBMITTED = 'Player Picks Submitted';
export const PICKS_AUTO_SELECTED = 'Player Picks Auto Selected';
export const HEAT_STREAK_PANEL_SELECTED = 'heat_streak';
export const SKILLS_TEST_ANSWERED_TRIGGER = 'Skills Test Answered';
export const LEADERBOARD_SEASON_TAB_SELECTED = 'Leaderboard Season Tab Selected';
export const LEADERBOARD_MONTHLY_TAB_SELECTED = 'Leaderboard Monthly Tab Selected';
export const LEADERBOARD_PLAYOFFS_TAB_SELECTED = 'Leaderboard Playoffs Tab Selected';
export const MONTHLY_CHALLENGE_TAB_SELECTED = (challengeNumber) => `Monthly Challenge ${challengeNumber} Selected`;
export const SCROLL_TO_TOP_CLICKED = 'Scroll to Top Clicked';
export const SCROLL_TO_POSITION_CLICKED = 'Scroll to Position Clicked';
export const PLAYOFFS_COMING_SOON_MAKE_PICKS_CLICKED = 'Playoffs Coming Soon Make Your Picks Clicked';
export const PLAYOFFS_COMING_SOON_CHECK_YOUR_STATS_CLICKED = 'Playoffs Coming Soon Check Your Stats Clicked';
export const SEASON_ENDED_MAKE_PICKS_CLICKED = 'Season Ended Make Your Picks Clicked';
export const SEASON_ENDED_CHECK_YOUR_STATS_CLICKED = 'Season Ended Check Your Stats Clicked';
export const CHALLENGE_ENDED_MAKE_PICKS_CLICKED = 'Challenge Ended Make Your Picks Clicked';
export const CHALLENGE_ENDED_CHECK_YOUR_STATS_CLICKED = 'Challenge Ended Check Your Stats Clicked';
export const GAME_INFO_TERMS_AND_CONDITIONS_CLICKED = 'Game Info See Terms and Conditions Clicked';
export const PLAY_NOW_TERMS_AND_CONDITIONS_CLICKED = 'Play Now See Terms and Conditions Clicked';
export const GAME_INFO_MAKE_YOUR_PICKS_CLICKED = 'Game Info Make Your Picks Clicked';

/**
 * AEP Events
 */

// eventTypes
export const CLICKED_TYPE = 'element_clicked';
export const VIEWED_TYPE = 'page_view';
export const SKILL_TEST_ANSWERED = 'skills_test_answered';
export const MODAL_OPENED_TYPE = 'modal_opened';

// modal names
export const SKILL_TESTING_QUESTION = 'skill_testing_question';
export const NOTIFICATIONS = 'notifications';
export const ONBOARDING = 'onboarding';

// element names
export const SUBMIT_ELEMENT = 'submit';
export const ANSWER_ELEMENT = 'answer';
export const PLAY_NOW_ELEMENT = 'play_now';
export const SUBMIT_PICKS_ELEMENT = 'submit_picks';
export const RANDOMLY_SELECT_PLAYERS_ELEMENT = 'randomly_select_players';
export const HISTORY_ELEMENT = 'history';
export const LEADERBOARD_ELEMENT = 'leaderboard';
export const LEADERBOARD_SEASON_ELEMENT = 'leaderboard_season';
export const LEADERBOARD_MONTHLY_ELEMENT = 'leaderboard_monthly';
export const LEADERBOARD_PLAYOFFS_ELEMENT = 'leaderboard_playoffs';
export const GAME_INFO_ELEMENT = 'game_info';
export const USER_STATS_ELEMENT = 'user_stats';
export const MAKE_YOUR_PICKS_ELEMENT = 'make_your_picks';
export const SEE_YOUR_POSITION = 'see_your_position';
export const SCROLL_TO_TOP = 'scroll_to_top';

// element types
export const BUTTON_TYPE = 'button';
export const TOGGLE_TYPE = 'toggle';
export const TAB_TYPE = 'tab';

// modal types
export const POPUP_TYPE = 'popup';

// element values
export const ON_VALUE = 'turn_on';
export const OFF_VALUE = 'turn_off';
export const CORRECT_VALUE = 'correct';
export const INCORRECT_VALUE = 'wrong';

// path

export const PATH = '/hockey_challenge';
